import { EnvironmentType } from 'dashboard/models/environment';
import {
  Organization,
  ProductFeatureName,
  ProductFeatureStatus,
} from 'dashboard/models/organization';

export function productFeatureDisabled(
  organization: Organization,
  name: ProductFeatureName,
  environmentType: EnvironmentType,
) {
  // all product features are disabled if we haven't loaded in an org's product-features (partial authenticated user)
  if (!organization.attributes['product-features']) {
    return true;
  }

  return (
    organization.attributes['product-features'].find(
      (productFeature) =>
        productFeature.name === name && productFeature['environment-type'] === environmentType,
    )?.status !== ProductFeatureStatus.Enabled
  );
}
